import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetUserDetails } from '../../../apis/users/get-user-details';


const useUserDetails = () => {
    const { id } = useParams<{ id: string }>();
    const [image, setImage] = useState("");
    const [zoomed, setZoomed] = useState(false);

    const { data, isLoading: loading } = useGetUserDetails(id!);

    const details = data ? {
        ...data?.data,
        completedOrders: data?.completedOrders,
        totalOrders: data?.totalOrders,
    } : null;

    const approvedMap: { [key: string]: string } = {
        true: "Yes",
        false: "No",
    };

    const createdByMap: { [key: string]: string } = {
        self: "No",
        admin: "Yes",
    };

    const handleImageClick = (src: string) => {
        setImage(src);
        setZoomed(true);
    };

    return {
        id,
        details,
        loading,
        image,
        zoomed,
        setZoomed,
        handleImageClick,
        approvedMap,
        createdByMap,
    };
};

export default useUserDetails;